<template>
  <div class="form-container u-margin-top">
    <div class="form">
      <p class="main-text">
        {{ $t('buyCredits.formPayment.title') }}
      </p>

      <div class="text-card">
        <p class="text-card-info">
          {{ $t('buyCredits.formPayment.cardDetail') }}
        </p>
        <img class="card-icons" src="../../assets/img/logo-visa.svg" />
        <img class="card-icons" src="../../assets/img/logo-mastercard.svg" alt="" />
        <img class="card-icons" src="../../assets/img/logo-american-express.svg" alt="" />
      </div>

      <form v-if="stripePublicKey">
        <div class="input--form">
          <label for="payment-card-number">{{ $t('buyCredits.formPayment.cardNumber') }}</label>
          <card-number
            ref="cardNumber"
            tabindex="0"
            class="input-text"
            :class="number ? 'complete' : null"
            :stripe="stripePublicKey"
            :options="stripeOptions"
            @change="number = $event.complete"
          />
        </div>

        <div class="form-container-mini">
          <div class="input--form">
            <label for="payment-card-expiry">{{ $t('buyCredits.formPayment.cardExpirate') }}</label>
            <card-expiry
              ref="cardExpiry"
              class="input-text mini"
              :class="expiry ? 'complete' : null"
              :stripe="stripePublicKey"
              :options="stripeOptions"
              @change="expiry = $event.complete"
            />
          </div>

          <div class="input--form mini">
            <label for="payment-card-cvc">{{ $t('buyCredits.formPayment.CardCvv') }}</label>
            <card-cvc
              ref="cardCvc"
              class="input-text mini"
              :class="cvc ? 'complete' : null"
              :stripe="stripePublicKey"
              :options="stripeOptions"
              @change="cvc = $event.complete"
            />
          </div>
        </div>

        <div class="input--form">
          <label for="">{{ $t('buyCredits.formPayment.cardName') }}</label>
          <input
            id="payment.cardName"
            ref="cardName"
            v-model="cardName"
            class="input-text"
            :class="{ complete: !$v.cardName.$invalid }"
            :placeholder="$t('buyCredits.formPayment.cardName')"
            type="text"
          />
        </div>
      </form>

      <div class="safe-info">
        <span class="glicon-lock"></span>
        <div class="safe-info-text">
          {{ $t('buyCredits.formPayment.safe') }}
        </div>
        <svg class="stipe-logo" xmlns="http://www.w3.org/2000/svg" width="110" height="30">
          <g fill="none" fill-rule="evenodd">
            <path
              fill="#32364E"
              d="M4.39 0h100.244a4.39 4.39 0 014.39 4.39v21.22a4.39 4.39 0 01-4.39 4.39H4.39A4.39 4.39 0 010 25.61V4.39A4.39 4.39 0 014.39 0z"
            />
            <path
              fill="#FFF"
              d="M52.246 19.482h-1.07l.829-2.046-1.649-4.16h1.13l1.037 2.831 1.044-2.83h1.13l-2.45 6.205zm-4.108-1.787c-.371 0-.751-.138-1.097-.405v.302h-1.104v-6.206h1.104v2.184c.346-.259.726-.397 1.097-.397 1.156 0 1.95.932 1.95 2.26 0 1.33-.794 2.262-1.95 2.262zm-.233-3.573c-.302 0-.605.13-.864.388v1.847c.26.26.562.389.864.389.621 0 1.053-.535 1.053-1.312 0-.776-.432-1.312-1.053-1.312zm-6.44 3.168a1.758 1.758 0 01-1.095.405c-1.148 0-1.95-.932-1.95-2.261 0-1.329.802-2.261 1.95-2.261.38 0 .76.138 1.096.397v-2.184h1.114v6.206h-1.114v-.302zm0-2.78c-.25-.259-.552-.388-.854-.388-.63 0-1.06.536-1.06 1.312 0 .777.43 1.312 1.06 1.312.302 0 .605-.13.855-.389V14.51zm-6.576 1.226c.069.656.587 1.105 1.312 1.105.397 0 .837-.147 1.286-.406v.923a3.514 3.514 0 01-1.467.337c-1.303 0-2.218-.95-2.218-2.295 0-1.304.898-2.227 2.131-2.227 1.13 0 1.9.889 1.9 2.158 0 .12 0 .258-.018.405h-2.926zm1.001-1.708c-.535 0-.949.396-1 .992h1.88c-.034-.587-.388-.992-.88-.992zm-3.91.68v2.884h-1.104v-4.316h1.105v.432c.31-.346.69-.535 1.06-.535.122 0 .243.009.364.043v.984a1.443 1.443 0 00-.389-.052c-.362 0-.75.199-1.035.56zm-4.928 1.028c.07.656.587 1.105 1.312 1.105.397 0 .837-.147 1.286-.406v.923a3.515 3.515 0 01-1.468.337c-1.303 0-2.217-.95-2.217-2.295 0-1.304.897-2.227 2.131-2.227 1.131 0 1.899.889 1.899 2.158 0 .12 0 .258-.017.405h-2.926zm1-1.708c-.534 0-.948.396-1 .992h1.882c-.035-.587-.389-.992-.881-.992zm-4.858 3.564l-.88-2.934-.872 2.934h-.993l-1.484-4.316h1.104l.872 2.935.872-2.935h1l.872 2.935.873-2.935h1.104l-1.476 4.316h-.992zm-6.75.103c-1.303 0-2.226-.94-2.226-2.261 0-1.329.923-2.261 2.226-2.261 1.304 0 2.218.932 2.218 2.26 0 1.322-.914 2.262-2.218 2.262zm0-3.599c-.647 0-1.096.544-1.096 1.338s.449 1.337 1.096 1.337c.64 0 1.088-.543 1.088-1.337 0-.794-.449-1.338-1.088-1.338zm-4.85 1.364H10.6v2.132H9.497v-5.938h2.097c1.208 0 2.07.785 2.07 1.907 0 1.122-.862 1.9-2.07 1.9zm-.156-2.908h-.837v2.01h.837c.639 0 1.087-.405 1.087-1 0-.605-.448-1.01-1.087-1.01zM100.118 16h-5.306c.121 1.27 1.052 1.644 2.108 1.644 1.076 0 1.923-.226 2.662-.6v2.184c-.736.408-1.708.703-3.004.703-2.64 0-4.489-1.653-4.489-4.922 0-2.76 1.569-4.952 4.147-4.952 2.574 0 3.918 2.192 3.918 4.967 0 .262-.024.83-.037.976zm-3.9-3.733c-.677 0-1.43.511-1.43 1.732h2.802c0-1.22-.705-1.732-1.371-1.732zm-8.427 7.664c-.948 0-1.528-.4-1.917-.686l-.006 3.067-2.71.576V10.24h2.386l.14.67a3.034 3.034 0 012.124-.851c1.903 0 3.696 1.714 3.696 4.87 0 3.444-1.774 5.004-3.713 5.004zm-.63-7.473c-.623 0-1.013.227-1.295.537l.016 4.027c.263.285.642.515 1.278.515 1.002 0 1.674-1.091 1.674-2.55 0-1.418-.682-2.53-1.674-2.53zm-7.831-2.22h2.72v9.499h-2.72v-9.5zm0-3.033l2.72-.579v2.208l-2.72.578V7.206zm-2.811 6.092v6.44H73.81v-9.5h2.343l.17.802c.634-1.166 1.902-.93 2.262-.8v2.49c-.344-.111-1.426-.273-2.066.568zm-5.72 3.107c0 1.597 1.71 1.1 2.058.961v2.206c-.362.199-1.017.36-1.903.36-1.608 0-2.814-1.185-2.814-2.79l.011-8.694 2.646-.562.002 2.353h2.059v2.31h-2.059v3.856zm-3.288.462c0 1.951-1.553 3.065-3.806 3.065a7.515 7.515 0 01-2.964-.616V16.73c.91.495 2.069.866 2.967.866.604 0 1.04-.163 1.04-.663 0-1.294-4.12-.807-4.12-3.807 0-1.919 1.465-3.067 3.663-3.067.898 0 1.795.138 2.693.496v2.552c-.824-.445-1.87-.697-2.695-.697-.568 0-.921.164-.921.588 0 1.219 4.143.64 4.143 3.87z"
            />
          </g>
        </svg>
      </div>
    </div>

    <div class="purchase-resume">
      <div class="purchase-resume--container">
        <p class="purchase-text">
          {{ $t('buyCredits.formPayment.orderData') }}
        </p>

        <div class="purchase-info">
          <p class="purchase-credits ligth-text">
            {{
              $t('buyCredits.formPayment.creditsNumber', {
                credits: formatCredits(purchaseData.credits)
              })
            }}
          </p>
          <span class="gl-text ligth-text"> {{ $t('buyCredits.formPayment.gamelearn') }}</span>
        </div>

        <div class="container--purchase-price">
          <div class="purchase-price-info">
            <div class="ligth-text">
              {{ $t('buyCredits.formPayment.creditPrice') }}
            </div>
            <div class="black-text">
              {{ $n(purchaseData.subtotal, 'currency', currency) }}
            </div>
          </div>

          <div class="purchase-price-info">
            <div class="ligth-text">{{ $t('buyCredits.formPayment.VAT') }}</div>
            <div class="black-text">{{ $n(vat, 'currency', currency) }}</div>
          </div>

          <span class="separator"></span>

          <div class="purchase-price-info">
            <div class="ligth-text">
              {{ $t('buyCredits.formPayment.total') }}
            </div>
            <div class="black-text">{{ $n(total, 'currency', currency) }}</div>
          </div>

          <span class="separator"></span>

          <div class="btn-container">
            <gl-button
              id="payment.submit"
              class="float--right"
              color-primary
              :type="'submit'"
              :text="$t('actions.finalize')"
              :disabled="!complete || creatingPayment"
              @onClick.prevent="createPayment"
            ></gl-button>
          </div>
        </div>
      </div>
    </div>
    <div class="form-container__backbtn">
      <gl-button
        id="payment.back"
        color-primary
        :icon-left="'glicon-left-arrow'"
        :type="'button'"
        :text="$t('actions.back')"
        @onClick.prevent="goBack"
      ></gl-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PaymentService from '../../services/payments.service';
import { required } from 'vuelidate/lib/validators';
import { CardNumber, CardExpiry, CardCvc, instance } from 'vue-stripe-elements-plus';

export default {
  name: 'PaymentForm',
  components: { CardNumber, CardExpiry, CardCvc },
  props: {
    purchaseData: { type: Object, default: null }
  },
  data() {
    return {
      stripe: null,
      intentData: null,
      total: null,
      vat: null,
      complete: false,
      creatingPayment: false,
      number: false,
      expiry: false,
      cardName: '',
      cvc: false,
      currency: 'USD',
      stripeOptions: {
        elements: {},
        style: {
          base: {
            color: '#32325d',
            fontFamily: '"Inter", sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '14px',
            '::placeholder': {
              color: '#aab7c4'
            },
            border: '5px solid red'
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
          }
        }
      }
    };
  },
  computed: {
    ...mapState({
      intentSecret: (state) => state.payments.intentSecret,
      creditsData: (state) => state.payments.creditsData,
      userData: (state) => state.profile.profileData,
      distributorData: (state) => state.distributors.distributorData,
      isEUCountry: (state) => state.payments.isEUCountry,
      stripePublicKey: (state) => state.payments.stripePublicKey
    })
  },
  watch: {
    number() {
      this.update();
    },
    expiry() {
      this.update();
    },
    cvc() {
      this.update();
    },
    cardName() {
      this.update();
    }
  },
  async created() {
    await this.$store.dispatch('getStripePublicKey');
    this.currency = this.isEUCountry ? 'EUR' : 'USD';
    this.applyVAT();
  },
  methods: {
    goBack() {
      this.$emit('showSlider', true);
    },
    update() {
      this.complete = this.number && this.expiry && this.cvc && !this.$v.cardName.$invalid;

      if (this.number) {
        if (!this.expiry) {
          this.$refs.cardExpiry.focus();
        } else if (!this.cvc) {
          this.$refs.cardCvc.focus();
        } else if (!this.cardName) {
          this.$refs.cardName.focus();
        }
      }
    },
    async createPayment() {
      this.creatingPayment = true;
      const cardData = this.$refs.cardNumber.$refs.element;
      await this.$store.dispatch('createPaymentIntent', {
        amount: this.total,
        currency: this.currency,
        description: this.$t('buyCredits.formPayment.creditsDescription'),
        purchaseType: 'credits'
      });

      const res = await instance.confirmCardPayment(this.intentSecret, {
        receipt_email: this.userData.email,
        payment_method: {
          card: cardData._element,
          billing_details: {
            name: this.cardName,
            email: this.userData.email
          }
        }
      });

      let paymentData = {
        amount: this.total,
        rateLimit: this.total,
        currency: this.currency,
        totalCredits: this.purchaseData.credits,
        description: this.$t('buyCredits.formPayment.creditsDescription'),
        clientId: this.userData.clientId,
        clientMail: this.userData.email,
        crmId: this.distributorData.crmId || '',
        status: res.paymentIntent.status,
        purchaseType: 'credits'
      };

      try {
        await PaymentService.createPayment(paymentData);
        this.$emit('makePurchase', paymentData);
      } catch (error) {
        console.error(error);
      }
    },
    applyVAT() {
      let vatPercent = 0;

      vatPercent = this.isEUCountry ? this.creditsData.taxRate : 0;

      this.vat = (vatPercent * this.purchaseData.subtotal) / 100;
      this.total = this.purchaseData.subtotal + this.vat;
    },
    formatCredits(value) {
      const val = value / 1;
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  },
  validations: {
    cardName: { required }
  }
};
</script>

<style lang="scss" scoped>
.main-text {
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 24px;
}
.form-container {
  display: flex;
  flex-wrap: wrap;

  &__backbtn {
    flex-basis: 100%;
    margin-top: 48px;
  }
}

.input-text:focus,
.input-text.StripeElement--focus {
  border-color: #f99a52;
}

.input--form {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  label {
    font-size: 12px;
    font-weight: 300;
    margin-bottom: 6px;
  }

  .input-text {
    box-sizing: border-box !important;
    height: 36px !important;
    width: 300px !important;
    border: 1px solid #e1e4e8;
    border-radius: 4px !important;
    background-color: #ffffff;
    font-family: inter;
    font-weight: 300;
    font-size: 13px;
    padding: 10px;
    &.StripeElement--focus {
      border: 1px solid var(--primary) !important;
    }
    &.mini {
      width: 138px !important;
    }
  }
}

.complete {
  background-color: rgba(68, 215, 171, 0.16) !important;
  border: 1px solid var(--success) !important;
}
.invalid {
  background-color: rgba(255, 99, 77, 0.16) !important;
  border: 1px solid var(--error) !important;
}
.form {
  width: 300px;
  margin-right: 72px;
}

.text-card {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.card-icons {
  box-sizing: border-box;
  height: 26px;
  width: 37.3px;
  border-radius: 1.7px;
  margin-right: 5px;
}

.text-card-info {
  margin-right: 35px;
  font-size: 14px;
  margin-bottom: 0;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.expiration {
  border: 1px solid #bbb;
}
.expiration input {
  border: 0;
  text-align: center;
  outline: 0; /* remove if you want input highlight */
}
.form-container-mini {
  display: flex;
  justify-content: space-between;
  width: 300px;
}

.purchase-resume {
  height: 334px;
  width: 316px;
  padding: 24px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 0 1px 0 rgba(10, 22, 70, 0.06), 0 6px 6px -1px rgba(10, 22, 70, 0.1);
}

.purchase-text {
  margin: 0;
  margin-bottom: 10px;
  font-weight: 500;
}

.purchase-credits {
  margin: 0;
}
.purchase-info {
  display: flex;
  font-size: 14px;
  margin-bottom: 37px;
}
.purchase-credits {
  margin-right: 4px;
}

.gl-text {
  color: #00a9e2;
}

.purchase-price-info {
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 35px;
}

.black-text {
  font-weight: 500;
}

.ligth-text {
  font-weight: 300 !important;
}

hr,
.separator {
  display: block;
  box-sizing: border-box;
  height: 1px;
  width: 269px;
  background-color: #e1e4e8;
  margin: 0;
  margin-bottom: 8px;
  margin-top: 8px;
}

.btn-container {
  margin-top: 25px;
  margin-right: 10px;
  text-align: center;
}

.safe-info {
  margin-top: 48px;
  display: flex;
  align-items: center;
}

.safe-info svg {
  margin-left: 16px;
}

.safe-info-text {
  margin-left: 5px;
  font-weight: 300;
  font-size: 12px;
}

.invalid {
  color: #fa755a;
}

input:active,
textarea:focus,
input:focus {
  outline: 0px !important;
  -webkit-appearance: none;
  box-shadow: none !important;
}

input::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #aab7c4 !important;
  opacity: 1;
  font-weight: 200;
  padding-left: 5px;
}
</style>
